import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { store, useStoreRechnung } from "../store"
import { EventBus } from "../eventbus"

export function RechnungsdatenSonstigeView() {
    const { t } = useTranslation()
    const { rechnungsdaten } = useStoreRechnung("rechnungsdaten")
    const onChange = useCallback<(element: string) => (value: unknown) => void>(
        (element: string) => (value: unknown) => {
            store.changeProperty(element, value)
            EventBus.instance.emit("changeProperty", element, value)
        },
        [],
    )

    return (
        <Components.Collapsible title={t("rechnung.rechnungsdaten.sonstigeRechnungsdaten.title")} collapsed={true}>
            <Components.FormGroup label={t("rechnung.rechnungsdaten.auftragsnummer.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsdaten.auftragsnummer.placeholder")}
                    onChange={onChange("rechnungsdaten.auftragsnummer")}
                    value={rechnungsdaten.auftragsnummer}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsdaten.vertragsnummer.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsdaten.vertragsnummer.placeholder")}
                    onChange={onChange("rechnungsdaten.vertragsnummer")}
                    value={rechnungsdaten.vertragsnummer}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsdaten.projektreferenz.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsdaten.projektreferenz.placeholder")}
                    onChange={onChange("rechnungsdaten.projektreferenz")}
                    value={rechnungsdaten.projektreferenz}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsdaten.vergabenummer.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsdaten.vergabenummer.placeholder")}
                    onChange={onChange("rechnungsdaten.vergabenummer")}
                    value={rechnungsdaten.vergabenummer}
                />
            </Components.FormGroup>

            {
                // BT-6 - Nach Abstimmungen in Rahmen von EPE-1210 entfernt, siehe Kommentar in https://jira.de.nortal.com/browse/EPE-1210
            }

            <Components.FormGroup label={t("rechnung.rechnungsdaten.kontierungsinfoUSt.label")}>
                <Components.DateEdit modelPath="rechnungsdaten.kontierungsinfoUSt" value={rechnungsdaten.kontierungsinfoUSt} />
            </Components.FormGroup>

            {
                // BT-8
                // Hier fehlt noch eine Komponente vom Typ drop
            }
            <Components.FormGroup label={t("rechnung.rechnungsdaten.kontierungsinfoUStCode.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsdaten.kontierungsinfoUStCode.placeholder")}
                    onChange={onChange("rechnungsdaten.kontierungsinfoUStCode")}
                    value={rechnungsdaten.kontierungsinfoUStCode}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsdaten.kontierungsinformationen.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsdaten.kontierungsinformationen.placeholder")}
                    onChange={onChange("rechnungsdaten.kontierungsinformationen")}
                    value={rechnungsdaten.kontierungsinformationen}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsdaten.refEmpfangsbestaetigung.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsdaten.refEmpfangsbestaetigung.placeholder")}
                    onChange={onChange("rechnungsdaten.refEmpfangsbestaetigung")}
                    value={rechnungsdaten.refEmpfangsbestaetigung}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsdaten.refVersandanzeige.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsdaten.refVersandanzeige.placeholder")}
                    onChange={onChange("rechnungsdaten.refVersandanzeige")}
                    value={rechnungsdaten.refVersandanzeige}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsdaten.objektkennung.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsdaten.objektkennung.placeholder")}
                    onChange={onChange("rechnungsdaten.objektkennung")}
                    value={rechnungsdaten.objektkennung}
                />
            </Components.FormGroup>
        </Components.Collapsible>
    )
}
